import type { UpsertQuoteDetailBody } from '@/lib/types'

// CPQ rule: `LABOR:*`, `OWNER FURNISHED:*` and `DAISY:PREWIRE:*` lines are
// never priced or costed. Labor dollars live on the `LABOR SUMMARY:*` lines
// (hours × rate); owner-furnished and prewire items are placeholders. The
// Dataverse plugin ZeroNoChargeItemPricing enforces the same rule server-side;
// this keeps the UI honest (no price/cost inputs, no priced create payload).
// `LABOR SUMMARY:` does not start with `LABOR:`, so summary lines keep money.
const NO_CHARGE_PREFIXES = ['LABOR:', 'OWNER FURNISHED:', 'DAISY:PREWIRE:']

export function isNoChargeLineName(name: string | null | undefined) {
  if (!name) return false
  const upper = name.trimStart().toUpperCase()
  return NO_CHARGE_PREFIXES.some((prefix) => upper.startsWith(prefix))
}

type NoChargeIdentity = {
  quotedetailname?: string | null
  productid?: { name?: string | null } | null
}

// Catalog product name determines pricing; stored line labels can be stale.
export function isNoChargeQuoteDetail(detail: NoChargeIdentity) {
  return isNoChargeLineName(detail.productid?.name)
}

const ZERO_LINE_PRICING = {
  priceperunit: 0,
  msdyn_costpriceperunit: 0,
  baseamount: 0,
  extendedamount: 0,
  tax: 0,
  msdyn_costamount: 0,
  msdyn_costtotal: 0,
  msdyn_estimatedcost: 0,
} satisfies UpsertQuoteDetailBody

export function withNoChargePricingCleared(body: UpsertQuoteDetailBody, productName: string): UpsertQuoteDetailBody {
  return isNoChargeLineName(productName) ? { ...body, ...ZERO_LINE_PRICING } : body
}
